var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4305 13.6159C34.8695 14.055 35.1859 14.6013 35.348 15.2006C36.2818 18.9593 36.066 24.8957 35.3662 28.7995C35.204 29.3987 34.8877 29.9451 34.4487 30.3841C34.0097 30.8231 33.4633 31.1395 32.864 31.3016C30.67 31.9 21.8398 31.9 21.8398 31.9C21.8398 31.9 13.0096 31.9 10.8156 31.3016C10.2163 31.1395 9.66995 30.8231 9.23094 30.3841C8.79193 29.9451 8.47557 29.3987 8.31343 28.7995C7.37414 25.057 7.63165 19.117 8.29528 15.2188C8.45742 14.6194 8.77378 14.073 9.21279 13.634C9.6518 13.195 10.1982 12.8787 10.7975 12.7165C12.9914 12.1182 21.8217 12.1 21.8217 12.1C21.8217 12.1 30.6519 12.1 32.8459 12.6984C33.4451 12.8606 33.9915 13.1769 34.4305 13.6159ZM26.3365 22L19.0113 26.2428V17.7571L26.3365 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8e928f980e7b9eb9787c4065e4916745.svg";
export { ForwardRef as ReactComponent };